import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CustomerAdminPage } from './customer-admin.page';

const routes: Routes = [
  {
    path: '',
    component: CustomerAdminPage,
    children: [
      {
        path: 'overview',
        loadChildren: () =>
          import('./customer-admin-overview/customer-admin-overview.module').then(
            (m) => m.CustomerAdminOverviewPageModule,
          ),
      },
      {
        path: 'members',
        loadChildren: () =>
          import('./customer-admin-members/customer-admin-members.module').then(
            (m) => m.CustomerAdminMembersPageModule,
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./customer-admin-settings/customer-admin-settings.module').then(
            (m) => m.CustomerAdminSettingsPageModule,
          ),
      },
      {
        path: 'templates',
        loadChildren: () =>
          import('./customer-admin-templates/customer-admin-templates.module').then(
            (m) => m.CustomerAdminTemplatesPageModule,
          ),
      },
      {
        path: 'outbound',
        loadChildren: () =>
          import('./customer-messaging/customer-messaging.module').then((m) => m.CustomerMessagingPageModule),
      },
      {
        path: 'conversations/:conversationId',
        loadComponent: () =>
          import('../../conversation-details/conversation-details.component').then(
            (m) => m.ConversationDetailsComponent,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerAdminPageRoutingModule {}
